import { Component, OnInit, ViewChild } from '@angular/core';
import {
  UserExtraInfoModel,
  UserModel,
  UsersService,
} from '../users/users.service';
import { BaseService } from '../../../base.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../toast.service';
import { NgForm } from '@angular/forms';
import { freeSet } from '@coreui/icons';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

import { TDocumentDefinitions, TDocumentInformation } from 'pdfmake/interfaces';
// Set the VFS for pdfMake
// (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-partnerpage',
  templateUrl: './partnerpage.component.html',
  styleUrls: ['./partnerpage.component.scss'],
})
export class PartnerpageComponent implements OnInit {
  constructor(
    public UsersService: UsersService,
    public BaseService: BaseService,
    public router: Router,
    public ToastService: ToastService
  ) {}
  icons = freeSet;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  msg: any;
  ModalVisible: boolean = false;
  ModalVisibleAddClient: boolean = false;
  customStylesValidated: boolean = false;
  Loading: boolean = false;
  ButtonLoading: boolean = false;
  PreviousPassowrd: any;
  EditMode: boolean = false;
  toggleModal() {
    if (this.ModalVisible) {
      this.customStylesValidated = false;
      this.UsersService.UserData = new UserModel();
      this.EditMode = false;
    }
    this.ModalVisible = !this.ModalVisible;
  }
  backupforuserExtraInfoData: any;
  toggleModalAddClient() {
    if (this.ModalVisibleAddClient) {
      this.customStylesValidated = false;
      this.UsersService.UserData = new UserModel();
      if (this.backupforuserExtraInfoData) {
        this.UsersService.UserExtraInfoData = this.backupforuserExtraInfoData;
      } else {
        this.UsersService.UserExtraInfoData = new UserExtraInfoModel();
      }
      this.EditMode = false;
    } else {
      this.UsersService.UserData = new UserModel();
      this.backupforuserExtraInfoData = this.UsersService.UserExtraInfoData;
      this.UsersService.UserExtraInfoData = new UserExtraInfoModel();
    }
    this.ModalVisibleAddClient = !this.ModalVisibleAddClient;
  }
  details_visible = Object.create({});
  toggleDetails(item: any) {
    this.details_visible[item] = !this.details_visible[item];
  }
  ClientsData: any;
  ClientsColumns: any = [
    {
      key: 'picture',
      label: 'Image',
      _style: { width: '15%' },
    },
    // {
    //   key: 'userName',
    //   label: 'User Name',
    //   _style: { width: '10%' },
    // },
    {
      key: 'companyName',
      label: 'Company',
      _style: { width: '15%' },
    },
    {
      key: 'userDisplayName',
      label: 'Name',
      _style: { width: '15%' },
    },
    {
      key: 'emailAddress',
      label: 'Email',
      _style: { width: '20%' },
    },
    {
      key: 'mobilePhoneNumber',
      label: 'Phone Number',
      _style: { width: '15%' },
    },
    // {
    //   key: 'address',
    //   label: 'Address',
    //   _style: { width: '20%' },
    // },
    {
      key: 'isActive',
      label: 'Status',
      _style: { width: '15%' },
    },
    // {
    //   key: 'Actions',
    //   label: '',
    //   _style: { width: '5%' },
    //   filter: false,
    //   sorter: false,
    // },
  ];
  PaymentsData: any;
  PaymentsColumns: any = [
    {
      key: 'docRefNo',
      label: 'Doc Ref No',
    },
    {
      key: 'invoiceDate',
      label: 'Invoice Date',
    },
    {
      key: 'user_Id',
      label: 'User ID',
    },
    {
      key: 'paymentType_Id',
      label: 'Payment Type',
    },
    {
      key: 'remarks',
      label: 'Remarks',
    },
    {
      key: 'isPaymentReceived',
      label: 'Payment Received',
    },
    // {
    //   key: 'Actions',
    //   label: '',
    //   _style: { width: '5%' },
    //   filter: false,
    //   sorter: false,
    // },
  ];

  ModalVisibleResetPassword: boolean = false;
  toggleModalResetPassword() {
    if (this.ModalVisibleResetPassword) {
      this.customStylesValidated = false;
      this.UsersService.UserData = new UserModel();
      this.EditMode = false;
    }
    this.ModalVisibleResetPassword = !this.ModalVisibleResetPassword;
  }
  confirmPassword: any;
  ResetPasswordModal(data: any) {
    this.UsersService.UserData = data;
    this.toggleModalResetPassword();
  }
  ngOnDestroy(): void {
    this.UsersService.UserExtraInfoData = new UserExtraInfoModel();
  }

  UserData: any;
  ngOnInit(): void {
    this.UsersService.selectedPartnerData.subscribe((data) => {
      this.UserData = data;
    });
    this.getUserExtraInfo();
    this.getClients();
    this.getPartnerPackages(this.UserData.id);
    // this.getInvoices();
    // this.generatePDFForInvoice({
    //   id: 1,
    //   externalDocumentNo: '123',
    //   billtoCustomerNo: '123',
    //   selltoCustomerNo: '123',
    //   orderNo: '123',
    //   orderDate: '123',
    //   invoiceDiscountAmount: 123,
    //   amountIncludingVAT: 123,

    // });
  }

  getUserExtraInfo() {
    this.UsersService.getUserExtraInfo().subscribe({
      next: (res: any) => {
        if (res.data.find((x: any) => x.users_Id == this.UserData.id)) {
          this.UsersService.UserExtraInfoData = res.data.find(
            (x: any) => x.users_Id == this.UserData.id
          );
        } else {
          this.UsersService.UserExtraInfoData = new UserExtraInfoModel();
        }

        console.log(
          '🚀 > ProfileComponent > this.UsersService.getUserExtraInfo >  this.UsersService.UserExtraInfoData:',
          this.UsersService.UserExtraInfoData
        );
        console.log('🚀 > UserpageComponent > getUserExtraInfo > res:', res);
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  // //getInvoices
  // getInvoices() {
  //   this.Loading = true;
  //   this.UsersService.getInvoices().subscribe({
  //     next: (res: any) => {
  //       console.log(res);
  //       this.PaymentsData = res.data;
  //       this.Loading = false;
  //     },
  //     error: (error) => {
  //       console.error(error);
  //       this.Loading = false;
  //     },
  //   });
  // }

  CheckTabAccessiblity(Parent: any, tabName: any) {
    let menuListString = localStorage.getItem('menuData') as string;
    let menuList = JSON.parse(menuListString);

    // console.log("🚀 > CheckTabAccessiblity > JSON.parse(menuListString):", JSON.parse(menuListString))

    let ParentMenuId = menuList?.find(
      (item: any) => item.url == Parent && item.isActive == true
    ).id;
    let TabMenus = menuList?.filter(
      (item: any) => item.parent_Id == ParentMenuId && item.isActive == true
    );
    if (
      TabMenus?.filter(
        (item: any) => item.url == tabName && item.isActive == true
      ).length > 0
    ) {
      return true;
    } else {
      return false;
    }
    return true;
  }

  getClients() {
    this.Loading = true;
    const data = {
      partner_Id:this.UserData.partner_Id,
      userType_Id: 6,
    }
    console.log(this.UserData);
    console.log(data);
    
    this.UsersService.getAllByUserTypeAndPartnerID(data).subscribe({
      next: (res: any) => {
        console.log(
          '🚀 > PartnerpageComponent > this.UsersService.getUsers > res:',
          res
        );
        this.ClientsData = res.data.filter(
          (item: any) =>
            item.userType_Id == 6 && item.partner_Id == this.UserData.id
        );
        this.ClientsData = res.data.map((client: any) => ({
          ...client,
          companyName: client.userExtraInfo?.length ? client.userExtraInfo[0].companyName : 'N/A',
        }));
        this.Loading = false;
      },
      error: (error) => {
        console.error(error);
        this.Loading = false;
      },
    });
  }
  PackagesData: any;
  SelectedPackageid: any;
  getPartnerPackages(id: any) {
    this.Loading = true;
    this.UsersService.getPackagesByPartnerid(id).subscribe({
      next: (res: any) => {
        console.log(res);
        this.PackagesData = res.data;
        this.SelectedPackageid = this.PackagesData.filter(
          (item: any) => item.isActive == true
        )?.id;
        this.Loading = false;
      },
      error: (error) => {
        console.error(error);
        this.Loading = false;
      },
    });
  }

  updatePackage(id: any) {
    const requestData: {
      user_Id: number;
      packageID_List: number[];
      date_Start: string;
      date_End: string;
    } = {
      user_Id: this.UserData.id,
      packageID_List: [],
      date_Start: new Date().toISOString(),
      date_End: new Date().toISOString(),
    };
    requestData.packageID_List.push(id);
    if (this.SelectedPackageid != undefined) {
      this.ButtonLoading = true;
      console.log(requestData);
      this.UsersService.AssignPackagesToPartner(requestData).subscribe({
        next: (response: any) => {
          console.log(response);
          if (response.isSuccess) {
            const options = {
              title: 'Success',
              delay: 3000,
              color: 'success',
              autohide: true,
              description: 'Level Updated Successfully',
              status: true,
            };
            this.ToastService.showToast(options);
          } else {
            const options = {
              title: 'Error',
              delay: 3000,
              color: 'danger',
              autohide: true,
              description: response.message,
              status: true,
            };
            this.ToastService.showToast(options);
          }
          this.ButtonLoading = false;
        },
        error: (error) => {
          this.ButtonLoading = false;
          const options = {
            title: 'Error',
            delay: 3000,
            color: 'danger',
            autohide: true,
            description: error.error.message,
            status: true,
          };
          this.ToastService.showToast(options);
        },
      });
    }
  }

  fileSelected: File | undefined;
  imageSrc: string | ArrayBuffer | undefined;
  onFileSelected(event: any) {
    console.log(event.target.files[0]);
    const maxAllowedSize = 2 * 1024 * 1024;
    if (event.target.files[0].size > maxAllowedSize) {
      alert('Only 2 MB size is allowed!');
      event.target.value = '';
    }
    const file: File = event.target.files[0];
    this.fileSelected = file;
    this.UsersService.UserData.file = file;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(file);
    }
    console.log(
      '🚀 > PromotionsComponent > onFileSelected > this.fileSelected:',
      this.fileSelected
    );
  }

  EditUser(data: any) {
    this.UsersService.UserData = data;
    this.toggleModal();
    this.EditMode = true;
  }

  UpdateUserDetails(
    UsersDetailsForm: any,
    UserData: any,
    PasswordUpdate?: boolean
  ) {
    this.customStylesValidated = true;
    if (UsersDetailsForm.invalid) {
      return;
    }
    console.log('pass', UserData.password);
    if (UserData.password == undefined || UserData.password == '') {
      UserData.password = '.';
    }
    this.ButtonLoading = true;
    UserData.approvedFrom = JSON.parse(
      localStorage.getItem('UserInfo')?.toString() || '{}'
    )?.id;
    UserData.createdBy = JSON.parse(
      localStorage.getItem('UserInfo')?.toString() || '{}'
    )?.id;

    console.log(
      '🚀 > UserpageComponent > UpdateUserDetails > UserData:',
      UserData
    );
    var formData = new FormData();
    var formDataOutput = '';
    Object.keys(UserData).forEach((key) => {
      if (UserData[key] != null) {
        formData.append(key, UserData[key]);
        formDataOutput += '\n' + key + ':' + UserData[key];
        console.log(key, UserData[key]);
      }
    });
    console.log(
      '🚀 > ProductsComponent > Object.keys > formDataOutput:',
      formDataOutput
    );

    this.UsersService.editUser(formData).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.isSuccess) {
          const options = {
            title: 'Success',
            delay: 3000,
            color: 'success',
            autohide: true,
            description: res.message,
            status: true,
          };
          this.ToastService.showToast(options);
          UserData.password = '';
          this.UsersService.selectedPartnerDataUpdate(UserData);
        } else {
          const options = {
            title: 'Failed',
            delay: 3000,
            color: 'danger',
            autohide: true,
            description: res.message,
            status: false,
          };
          this.ToastService.showToast(options);
          setTimeout(() => {
            this.msg = undefined;
          }, 3000);
        }
        this.ButtonLoading = false;
        if (PasswordUpdate) {
          this.toggleModalResetPassword();
        } else {
          this.toggleModal();
        }
      },
      error: (error) => {
        console.error(error);
        alert('Error: ' + error.error.message);
      },
    });

    // this.router.navigate(['/partners']);
  }

  DeleteUser(item: any) {
    if (!confirm('Are you sure you want to delete this User?')) {
      return;
    }
    this.UsersService.deleteUser(item.id).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.isSuccess) {
          this.msg = res;
          setTimeout(() => {
            this.msg = undefined;
            const options = {
              title: 'Success',
              delay: 3000,
              color: 'success',
              autohide: true,
              description: res.message,
              status: true,
            };
            this.ToastService.showToast(options);
          }, 1000);
          this.router.navigate(['/partners']);
          // this.getProducts();
        } else {
          this.msg = res;
          this.msg = undefined;
          const options = {
            title: 'Failed',
            delay: 3000,
            color: 'danger',
            autohide: true,
            description: res.message,
            status: false,
          };
          this.ToastService.showToast(options);
        }
      },
      error: (error) => {
        console.error(error);
        alert('Error: ' + error.error.message);
      },
    });
  }

  OpenUserPage(item: any) {
    console.log('🚀 > OpenUserPage > item:', item.item);
    this.UsersService.selectedClientDataUpdate(item.item);
    this.router.navigate(['/clientpage']);
  }

  AddClientCall(UserDetailsForm: any, UserData: any) {
    console.log(
      '🚀 > PartnerpageComponent > AddClientCall > UserData:',
      UserData
    );
    this.ButtonLoading = true;
    this.customStylesValidated = true;
    if (UserDetailsForm.invalid) {
      this.ButtonLoading = false;
      return;
    }
    UserData.createdBy = JSON.parse(
      localStorage.getItem('UserInfo')?.toString() || '{}'
    )?.id;
    UserData.aspUserID = '.';
    UserData.isEmailVerified = false;
    UserData.isMobilePhoneVerified = false;
    UserData.partner_Id = this.UserData.partner_Id;
    UserData.userType_Id = 6;
    UserData.userName = UserData.emailAddress;
    UserData.password = this.UsersService.generateRandomPassword(8);
    UserData.firstName = UserData.userDisplayName;
    UserData.lastName = UserData.userDisplayName;

    var formData = new FormData();
    var formDataOutput = '';
    Object.keys(UserData).forEach((key) => {
      if (UserData[key] != null) {
        formData.append(key, UserData[key]);
        formDataOutput += '\n' + key + ':' + UserData[key];
        console.log(key, UserData[key]);
      }
    });
    console.log(
      '🚀 > ProductsComponent > Object.keys > formDataOutput:',
      formDataOutput
    );

    this.UsersService.addUser(formData).subscribe({
      next: (res: any) => {
        console.log(res);
        this.msg = res;
        setTimeout(() => {
          this.msg = undefined;
        }, 3000);
        this.getClients();
        this.ButtonLoading = false;
        this.toggleModalAddClient();
      },
      error: (error) => {
        console.error(error);
        this.ButtonLoading = false;
        // alert("Error: " + error.error.message);
      },
    });
  }

  validatePhoneNumberInput(event: KeyboardEvent): void {
    const allowedChars = /[0-9\s()+-]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }

  EditUserExtraInfo(UserExtraInfoForm: NgForm) {
    this.customStylesValidated = true;
    if (UserExtraInfoForm.invalid) {
      return;
    }
    this.ButtonLoading = true;

    console.log(
      '🚀 > UserpageComponent > EditUserExtraInfo > UserExtraInfoForm:',
      UserExtraInfoForm
    );

    this.UsersService.UserExtraInfoData.users_Id = this.UserData.id;

    this.UsersService.editUserExtraInfo(
      this.UsersService.UserExtraInfoData
    ).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.isSuccess) {
          const options = {
            title: `Success`,
            delay: 3000,
            color: 'success',
            autohide: true,
            description: 'Partner profile has been updated successfully',
            status: true,
          };
          this.ToastService.showToast(options);
          this.ngOnInit();
        } else {
          const options = {
            title: `Error`,
            delay: 3000,
            color: 'danger',
            autohide: true,
            description: res.message,
            status: false,
          };
          this.ToastService.showToast(options);

          setTimeout(() => {
            this.msg = undefined;
          }, 3000);
        }
        this.customStylesValidated = false;
        this.ButtonLoading = false;
      },
      error: (error) => {
        console.error(error);
        alert('Error: ' + error.error.message);
      },
    });
  }

  ImageData: any;
  async convertToBase64FromPath(path: string): Promise<void> {
    console.log('convertToBase64FromPath');
    const img = new Image();
    img.src = path;

    await new Promise<void>((resolve) => {
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0);
        const base64String = canvas.toDataURL();
        this.ImageData = base64String;
        resolve();
      };
    });
  }

  generatePassword(): void {
    this.UsersService.UserData.password =
      this.UsersService.generateRandomPassword(12);
    this.confirmPassword = this.UsersService.UserData.password;
  }

  generatePDFForInvoice(item: any) {
    console.log('PDF GENERATE FOR INVOICE');
    console.log(item);
    this.convertToBase64FromPath('assets/brand/x2xLogo.png').then(() => {
      const image = this.ImageData;
      var body = {
        CountryList_Id: localStorage.getItem('country'),
        ordeHeaderID: item.id,
      };

      const LineItems = item.details;
      var LinesForPDF: any[] = [];
      LinesForPDF.push([
        { text: 'Product', bold: true },
        { text: 'Feature', bold: true },
        { text: 'License Id', bold: true, style: { alignment: 'right' } },
        { text: 'Amount', bold: true, style: { alignment: 'right' } },
        { text: 'Tax', bold: true, style: { alignment: 'right' } },
      ]);
      LineItems.forEach((element: any) => {
        LinesForPDF.push([
          element._Product_Name,
          element._Feature_Name,
          { text: element.license_Id, style: { alignment: 'right' } },
          {
            text: element.feature_SalesAmount.toFixed(2),
            style: { alignment: 'right' },
          },
          {
            text: element.feature_TaxAmount.toFixed(2),
            style: { alignment: 'right' },
          },
        ]);
      });

      this.DocumentData = {
        content: [
          { image: image, width: 150, margin: [0, 0, 0, 15] },
          { text: 'x2x eCommerce Partner Portal', style: 'header' },
          {
            text: '201-435 North Service Road West, Oakville, ON L6M 4X8',
            style: { fontSize: 9 },
          },
          {
            text: 'Phone (800)268-8174 \t\t   Fax (905)247-0628',
            style: { fontSize: 9 },
          },
          {
            text: 'sales@alsafafoods.com  \t https://www.alsafahalal.com',
            style: { fontSize: 9 },
            margin: [0, 0, 0, 15],
          },
          // {
          //   style: 'headerData',
          //   layout: 'noBorders',
          //   table: {
          //     widths: ['60%', '40%'],
          //     body: [
          //       [
          //         { text: 'Bill To:', bold: true, style: { fontSize: 10 } },
          //         { text: 'Ship To:', bold: true, style: { fontSize: 10 } },
          //       ],
          //       // [item.billtoCustomerNo, item.selltoCustomerNo],
          //       // [item.billToAddressLine1 + item.billToAddressLine2, item.sellToAddressLine1+ item.sellToAddressLine2],
          //       // [item.billToCity+ ', ' +item.billToPostCode, item.sellToCity+ ', ' +item.sellToPostCode],
          //       // [item.billToCountryOrRegion, item.sellToCountryOrRegion],
          //       // [item.phoneNumber, ' '],
          //     ],
          //   },
          // },
          {
            style: 'headerData',
            layout: 'noBorders',
            table: {
              widths: ['25%', '30%'],
              body: [
                [
                  'Document Reference No. :',
                  {
                    text: item.docRefNo,
                    style: { alignment: 'right' },
                  },
                ],
                [
                  'Invoice Date :',
                  {
                    text: new Date(item.invoiceDate).toLocaleDateString(),
                    style: { alignment: 'right' },
                  },
                ],
                // [
                //   'User ID :',
                //   { text: item.user_Id, style: { alignment: 'right' } },
                // ],
                // [
                //   'Payment Type :',
                //   { text: item.paymentType_Id, style: { alignment: 'right' } },
                // ],
                // [
                //   'Remarks :',
                //   { text: item.remarks, style: { alignment: 'right' } },
                // ],
                [
                  'Status :',
                  {
                    text: item.isPaymentReceived ? 'Paid' : 'Unpaid',
                    style: { alignment: 'right' },
                  },
                ],
                // [
                //   'Bill-to Customer No. :',
                //   {
                //     text: item.billtoCustomerNo,
                //     style: { alignment: 'right' },
                //   },
                // ],
                // ['Customer Name :' , {text: item.customerName,  style: {  alignment: 'right'}}],
                // [
                //   'Order No :',
                //   { text: item.orderNo, style: { alignment: 'right' } },
                // ],
                // [
                //   'Order Date :',
                //   { text: item.orderDate, style: { alignment: 'right' } },
                // ],
                // ['Payment Method :' , {text: item.paymentMethodCode,  style: {  alignment: 'right'}}],
                // ['Salesperson :' , {text: item.salesPerson,  style: {  alignment: 'right'}}],
                // ['Email :' , {text: item.email,  style: {  alignment: 'right'}}],
              ],
            },
          },
          {
            style: 'tableExample',
            layout: 'headerLineOnly',
            table: {
              headerRows: 1,
              widths: ['20%', '40%', '15%', '15%', '10%'],
              body: LinesForPDF,
            },
          },
          // {
          //   style: 'headerData',
          //   table: {
          //     widths: ['40%'],
          //     body: [
          //       [
          //         {
          //           text: 'Notes:\n Delivery Hours: 02:58 To 06:58 | Special Instructions: tst | Dock Available: Yes  Point of Contact: tst ',
          //           bold: true,
          //           style: { fontSize: 10 },
          //         },
          //       ],
          //     ],
          //   },
          // },
          // {
          //   style: 'headerData',
          //   table: {
          //     widths: ['50%', '50%'],
          //     body: [
          //       // ['Amount Subject to Sales Tax', {text: item?.amount?.toFixed(2), style: {  alignment: 'right'}}],
          //       // ['Subtotal', {text: item?.amount?.toFixed(2), style: {  alignment: 'right'}, bold: true}],
          //       [
          //         'Discount ',
          //         {
          //           text: item?.invoiceDiscountAmount?.toFixed(2),
          //           style: { alignment: 'right' },
          //           bold: true,
          //         },
          //       ],
          //       // ['Total Tax', {text: item?.subtotalAmountExcludingTax?.toFixed(2), style: {  alignment: 'right'}}],
          //       [
          //         'Total Amount',
          //         {
          //           text: item?.amountIncludingVAT?.toFixed(2),
          //           style: { alignment: 'right' },
          //           bold: true,
          //         },
          //       ],
          //     ],
          //   },
          // },
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
          },
          tableExample: {
            fontSize: 9,
            margin: [0, 5, 0, 15],
          },
          headerData: {
            fontSize: 9,
            // bold: true,
            margin: [0, 5, 0, 15],
          },
        },
      };
      const pdfFonts = {
        // download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf',
          bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf',
          italics:
            'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Italic.ttf',
          bolditalics:
            'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-MediumItalic.ttf',
        },
      };

      pdfMake.createPdf(this.DocumentData, undefined, pdfFonts).open();
    });
    // console.log(image);
  }

  DocumentData: TDocumentDefinitions | undefined;
  generatePdf(userData: any) {
    this.DocumentData = {
      content: [
        { text: 'User Information' },
        { text: `Login ID: ${userData.loginID}`, style: 'subheader' },
        { text: `User Type ID: ${userData.userType_Id}`, style: 'subheader' },
        { text: `Other Info: ${JSON.stringify(userData)}`, style: 'subheader' },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        subheader: {
          fontSize: 14,
          margin: [0, 10, 0, 5],
        },
      },
    };
    const pdfFonts = {
      // download default Roboto font from cdnjs.com
      Roboto: {
        normal:
          'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf',
        italics:
          'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics:
          'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-MediumItalic.ttf',
      },
    };

    pdfMake.createPdf(this.DocumentData, undefined, pdfFonts).open();
  }

  MarkAsApproved(item: any) {
    if (!confirm('Are you sure you want to approve this User?')) {
      return;
    }
    //Set Approval
    var body = {
      id: item.id,
      isApproved: true,
      sendEmail: true,
    };
    this.UsersService.SetApproval(body).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.isSuccess) {
          const options = {
            title: 'Success',
            delay: 3000,
            color: 'success',
            autohide: true,
            description: res.message,
            status: true,
          };
          this.ToastService.showToast(options);
          item.isApproved = true;
          this.UsersService.selectedPartnerDataUpdate(item);
        } else {
          const options = {
            title: 'Failed',
            delay: 3000,
            color: 'danger',
            autohide: true,
            description: res.message,
            status: false,
          };
          this.ToastService.showToast(options);
        }
      },
      error: (error) => {
        console.error(error);
        alert('Error: ' + error.error.message);
      },
    });
  }

  @ViewChild('RegisterForm') RegisterForm: NgForm | undefined;
  EmailExists: boolean = false;
  checkUserName(username: string, myForm: NgForm) {
    console.log('🚀 > RegisterComponent > checkUserName > username:', username);
    console.log('Focus OUT');
    this.UsersService.CheckUserName(username).subscribe(
      (response: any) => {
        console.log(response);
        if (!response.isSuccess) {
          this.RegisterForm?.control
            .get('Email')
            ?.setErrors({ EmailExists: true });
          this.EmailExists = true;
        } else {
          this.EmailExists = false;
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  AddUserCall2(
    UserDetailsForm: any,
    UserData: any,
    UserExtraInfoData: UserExtraInfoModel
  ) {
    console.log(
      '🚀 > RegisterComponent > AddUserCall > UserDetailsForm:',
      UserDetailsForm
    );

    console.log('🚀 > UsersComponent > onSubmitUserForm > UserData:', UserData);
    this.ButtonLoading = true;
    this.customStylesValidated = true;
    
    UserData.createdBy = JSON.parse(
      localStorage.getItem('UserInfo')?.toString() || '{}'
    )?.id;
    UserData.aspUserID = '.';
    UserData.isEmailVerified = false;
    UserData.isMobilePhoneVerified = false;
    UserData.partner_Id = this.UserData.partner_Id;
    UserData.userType_Id = 6;
    UserData.userName = UserData.emailAddress;
    UserData.UserDisplayName = UserData.firstName + ' ' + UserData.lastName;
    UserData.address = '.';

    var formData = new FormData();
    var formDataOutput = '';
    Object.keys(UserData).forEach((key) => {
      if (UserData[key] != null) {
        formData.append(key, UserData[key]);
        formDataOutput += '\n' + key + ':' + UserData[key];
        console.log(key, UserData[key]);
      }
    });
    console.log(
      '🚀 > ProductsComponent > Object.keys > formDataOutput:',
      formDataOutput
    );

    this.UsersService.addUser(formData).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.isSuccess) {
          UserExtraInfoData.users_Id = res.reserved_A;
          console.log(
            '🚀 > RegisterComponent > this.UsersService.addUserExtraInfo > UserExtraInfoData:',
            UserExtraInfoData
          );
          this.UsersService.addUserExtraInfo(UserExtraInfoData).subscribe({
            next: (res: any) => {
              console.log(res);
              if (res.isSuccess) {
                // this.ModalVisible = false;

                // this.imageField.nativeElement.value = '';
                this.UsersService.UserData = new UserModel();
                this.UsersService.UserExtraInfoData = new UserExtraInfoModel();
                this.customStylesValidated = false;
                this.ButtonLoading = false;

                // this.router.navigate(['/login']);
                const options = {
                  title: `Account Created`,
                  delay: 3000,
                  color: 'success',
                  autohide: true,
                  description: 'Account Created Successfully',
                  status: true,
                };
                this.ToastService.showToast(options);
                // this.getUsers();
                this.toggleModalAddClient();
                this.ngOnInit();
              } else {
                const options = {
                  title: `Error`,
                  delay: 3000,
                  color: 'danger',
                  autohide: true,
                  description: res.apiStatus.message,
                  status: false,
                };
                this.ToastService.showToast(options);
                this.ButtonLoading = false;
              }
              this.ButtonLoading = false;
            },
            error: (error) => {
              console.error(error);
            },
          });
        } else {
          const options = {
            title: `Error`,
            delay: 3000,
            color: 'danger',
            autohide: true,
            description: res.message,
            status: false,
          };
          this.ToastService.showToast(options);
          this.ButtonLoading = false;
        }
      },
      error: (error) => {
        console.error(error);
        this.ButtonLoading = false;
        // alert("Error: " + error.error.message);
      },
    });
  }
}
